import { Component, EventEmitter, Input, Output, OnInit, ElementRef, Renderer2, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Language } from 'src/app/language';
import { Filter, FilterComparisonOperator, FilterIdExtractor, FilterKey, FilterType, getRangeKey } from '../../models';

@Component({
  selector: 'filters-bar',
  templateUrl: './filters-bar.component.html',
  styleUrls: ['./filters-bar.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FiltersBarComponent implements OnInit {

  @Input('filters') set filters(filters: Filter[]) {
    this.options = filters.map(filter => this.getItemFromFilter(filter))
  }
  @Input('language') language: Language;
  @Input('selectedFilters') set selectedFilters(filters: Filter[]) {
    this.selected_items = [];
    this.selected_items = this.getItemsFormFilters(filters);
  }
  @Input() options: Array<Item>;
  @Input() placeholder: string;
  @Input() resultsCount: number = 0;
  @Input() resultsPaginationCount: number = 0;
  @Output() onSelect = new EventEmitter<Filter>();
  @Output() onRemove = new EventEmitter<Filter>();
  @Output() onRemoveAll = new EventEmitter<void>();
  @Output() onSubmitBloque = new EventEmitter<string>();
  @ViewChild('selector') selector: ElementRef;
  @ViewChild('input') input: ElementRef;
  @ViewChild('list') list: ElementRef;
  display_list: boolean = false;
  items_selected = 0;
  selected_items: Array<Item> = [];
  filter: string;
  searchFocus: boolean = false;
  bloqueFilter: string;

  get availableOptions(): Item[] {
    const rawOptions: Item[] = [...this.options];
    const availableOptions: Item[] = [];

    for(const item of rawOptions) {
      if(!availableOptions.find(i => i.id === item.id)
      && !this.selected_items.find(i => i.id === item.id)) {
        availableOptions.push(item);
      }
    }

    return availableOptions;
  }

  getItemFromFilter(filter: Filter): Item {
    return {
      id: FilterIdExtractor(filter),
      text: `${filter.name}`,
      filter: filter
    }
  }

  getItemsFormFilters(filters: Filter[]): Item[]{
    const nonRangeFilters: Filter[] = filters.filter(f => f.type !== FilterType.RANGE);
    const rangeFilters: Filter[] = filters.filter(f => f.type === FilterType.RANGE);
    const rangeItems: Item[] = this.getRageFiltersItem(rangeFilters);
    return [
      ...nonRangeFilters.map(f => this.getItemFromFilter(f)),
      ...rangeItems
    ]
  }

  getRageFiltersItem(filters: Filter[]) {
    const greaterFilters: Filter[] = filters.filter(f => f.comparator === FilterComparisonOperator.LESS_OR_EQUAL_THAN);
    const lessFilter: Filter[] = filters.filter(f => f.comparator === FilterComparisonOperator.GREATER_OR_EQUAL_THAN);
    return lessFilter.map(lf => {
      const gFilter: Filter = greaterFilters.find(gf => getRangeKey(gf.key) === getRangeKey(lf.key));
      return {
        id: FilterIdExtractor(lf),
        text: `${lf.name} (${lf.value} ${this.language.A} ${gFilter.value})`,
        filter: lf
      }
    })
  }

  select(item: Item) {
    const exists: boolean = !!this.selected_items.find(itm => itm.id === item.id);
    if(exists) return void(0);
    this.onSelect.emit(item.filter);
    this.filter = '';
    this.selected_items.push(item);
    this.close(true);
  }

  delete(item: Item) {
    const i: number = this.selected_items.findIndex(si => si.id === item.id);
    this.selected_items.splice(i, 1);
    this.options.push(item);
    this.onRemove.emit(item.filter);
  }

  close(force?: boolean) {
    if (!this.list_hovered || force) {
      this.display_list = false;
    }
  }

  trackItem(index: number, el): number {
    return el.id;
  }

  place_holder() {
    if (this.items_selected < 1) {
      return this.placeholder
    } else {
      return '';
    }
  }

  keepopen(i) {
    this.hover = i;
    if (this.display_list) {
      this.list_hovered = true;
    } else {
      this.list_hovered = false;
    }
  }

  list_hovered: boolean;

  options_array() {
    if (!this.options || !this.filter) {
      return this.availableOptions;
    }
    return this.availableOptions.filter(item => item.text.toLowerCase().indexOf(this.filter.toLowerCase()) != -1);
  }

  key(e) {

    if (e.keyCode == 40 && this.hover < (this.options_array().length - 1) && !this.list_hovered) {
      this.hover++;
      if (this.list.nativeElement.childNodes[this.hover + 2].offsetTop > (this.list.nativeElement.scrollTop + this.list.nativeElement.offsetHeight)) {
        this.list.nativeElement.scrollTop =
        ((this.list.nativeElement.childNodes[this.hover + 2].offsetTop + this.list.nativeElement.childNodes[this.hover + 3].offsetHeight) - this.list.nativeElement.offsetHeight)
      }
      return false;
    }
    else if (e.keyCode == 38 && this.hover > 0 && !this.list_hovered) {
      this.hover--;
      if (this.list.nativeElement.childNodes[this.hover].offsetTop < (this.list.nativeElement.scrollTop)) {
        this.list.nativeElement.scrollTop =
          (this.list.nativeElement.childNodes[this.hover].offsetTop - this.list.nativeElement.childNodes[this.hover].offsetHeight)
      }
      return false;
    }

    else if (e.keyCode == 13) {
      if(this.display_list && this.filter){
        this.select(this.options_array()[this.hover]);
        this.hover = 0;
      }
      return false;
    }

    else if (e.keyCode == 27) {
      this.close(true)
      return false;
    }

    else {
      this.display_list = true
    }
  }

  hover: number = 0;
  ishover(i) {
    return this.hover === i;
  }

  submitBloque(): void {
    this.onSubmitBloque.emit(this.bloqueFilter);
    this.bloqueFilter = '';
    document.getElementById('#filter-bloque').blur();
  }
  constructor(
    private element: ElementRef,
    private renderer: Renderer2,

  ) { }

  ngOnInit() {
    document.addEventListener('click', () => this.close);
    document.addEventListener('keydown', (e: KeyboardEvent) => {
      if(e.key == 'b' && e.ctrlKey) {
        this.input.nativeElement.focus()
      }
    })
  }

}

interface Item {
  id: string;
  text: string;
  filter: Filter;
}
